import React, { useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const AssetSchemaTab = ({ currentAsset }) => {
  const tableRef = useRef(null);

  const scrollTable = (direction) => {
    if (tableRef.current) {
      const scrollAmount = 200;
      tableRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  if (!currentAsset) return null;

  return (
    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
      <div className="p-6 border-b border-gray-200 flex items-center justify-between">
        <div>
          <h3 className="text-lg font-bold text-gray-800 mb-2 flex items-center">
            <div className="w-[5px] h-6 bg-violet-500 rounded mr-3"></div>
            Schema Details
          </h3>
          <p className="text-sm pl-2 text-gray-600">{currentAsset.tableDetails?.length || 0} columns</p>
        </div>
        <div className="flex items-center gap-1 text-gray-400 text-sm">
          <button 
            onClick={() => scrollTable('left')}
            className="p-1 hover:bg-gray-100 rounded transition-colors"
            title="Scroll left"
          >
            <ChevronLeft className=" h-5" />
          </button>
          <span>Scroll</span>
          <button 
            onClick={() => scrollTable('right')}
            className="p-1 hover:bg-gray-100 rounded transition-colors"
            title="Scroll right"
          >
            <ChevronRight className=" h-5" />
          </button>
        </div>
      </div>
      <div className="overflow-x-auto" ref={tableRef}>
        <table className="w-full">
          <thead>
            <tr className="bg-gray-50">
              <th className="text-left py-3 px-6 text-sm font-semibold text-gray-700">Column Name</th>
              <th className="text-left py-3 px-6 text-sm font-semibold text-gray-700">Data Type</th>
              <th className="text-left py-3 px-6 text-sm font-semibold text-gray-700">CDE</th>
              <th className="text-left py-3 px-6 text-sm font-semibold text-gray-700">Sample</th>
            </tr>
          </thead>
          <tbody>
            {currentAsset.tableDetails?.map((col, index) => (
              <tr key={col.attribute_id || index} className="border-t border-gray-100">
                <td className="py-3 px-6 text-sm font-mono text-gray-900">{col.name}</td>
                <td className="py-3 px-6 text-sm text-gray-700">{col.type || 'N/A'}</td>
                <td className="py-3 px-6">
                  <span className={`inline-flex px-2 py-1 rounded-full text-xs font-medium ${
                    col.is_cde ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'
                  }`}>
                    {col.is_cde ? 'Yes' : 'No'}
                  </span>
                </td>
                <td className="py-3 px-6 text-sm text-gray-700 max-w-xs truncate" title={col.sample}>
                  {col.sample || 'N/A'}
                </td>
              </tr>
            ))}
            {(!currentAsset.tableDetails || currentAsset.tableDetails.length === 0) && (
              <tr>
                <td colSpan="4" className="py-6 text-center text-gray-500">No schema details available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AssetSchemaTab;
